import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { toastr } from 'react-redux-toastr';
import { bindActionCreators } from 'redux';
import { GenericError, PagedList, pagedListUtilities, dateUtilities, SearchComponent, emailUtilities, accessibilityNotificationsEmitter, ConfirmModalWindow, SiteProgramSearchComponent } from '../../common'
import { tenantHelpers } from '../../tenantInfo';
import * as unregisteredParticipantsActions from './unregistered-participants.actions';
import * as sitesActions from '../../permissions/touchpoint/site-list-folder/site-list.actions';
import './unregistered.scss';
import  moment from 'moment';
import { RadioElement } from '../../common/form-elements';
const emptyGuid = '00000000-0000-0000-0000-000000000000';
import { List } from 'immutable';


function findParticipant(id, participantList){
  return participantList.find(part => !!part.demographics && part.demographics.externalId === id);
}

export class UnregisteredParticipantsComponent extends Component {

  componentDidUpdate(prevProps, prevState) {
    const { showConfirmModal : previousConfirm } = prevProps;
    const { unregisteredParticipants } = this.props;
    const { showConfirmModal } = unregisteredParticipants;
    if(showConfirmModal && !previousConfirm) {
      var confirmButton = document.getElementById('confirm');
      if(confirmButton) confirmButton.focus();
    }
  }

  componentDidMount() {
    const { unregisteredParticipantsActions, sitesActions } = this.props;
    unregisteredParticipantsActions.fetchList();
    const { fetchSiteProgramEnabledList } = sitesActions || {};

    fetchSiteProgramEnabledList();
  }

  componentWillUpdate(nextProps, nextState) {
    const { unregisteredParticipantsActions } = this.props;
    unregisteredParticipantsActions.fetchList();
  }

    /**
   * Function that executes when the user selects the site on the add intake modal
   * @param {Guid} selectedSite : the Guid of the site of which to create the intake form
   */
  handleUpdateSite(selectedSiteId) {
    const { sitesActions, sites } = this.props;
    const { changeSelectedSite } = sitesActions || {};
    const { fetchProgramsForSite } = sitesActions || {};
    const { siteListState } = sites || {};
    const siteData = siteListState && siteListState.data && siteListState.data.results;
    const siteIndex = siteData && siteData.findIndex(res => res.id === selectedSiteId);
    const selectedSite = siteData && siteData[siteIndex];
    changeSelectedSite(selectedSiteId);
    if (!!selectedSite) fetchProgramsForSite(selectedSiteId);
  }

  /**
   * Function that executes when the user selects the program on the add intake modal
   * @param {Guid} selectedProgramId : the Guid of the program of which to create the intake form
   */
  handleUpdateProgram(selectedProgramId) {
    const { sitesActions } = this.props;
    const { changeSelectedProgram } = sitesActions || {};

    changeSelectedProgram(selectedProgramId);
  }

  /**
   * Function that calls the action class to update the store with the radiobutton element
   * @param {string} value : value of the radiobutton element
   */
  handleSelectionChange(value) {
    const { unregisteredParticipantsActions, sitesActions } = this.props;
    const option = !!value && value.size > 0 ? value.get(0) : undefined;
    const radioButtonOption = (option === 'true');
    if(!radioButtonOption) {
      sitesActions.clearSiteProgramIds();
    }
    unregisteredParticipantsActions.setSelectedSaveOption(option);
  }

  renderParticipant(participant) {
    const guidEmpty = '00000000-0000-0000-0000-000000000000';
    const { unregisteredParticipants, unregisteredParticipantsActions } = this.props;
    const { selectParticipant } = unregisteredParticipantsActions;
    const { participantsToRegister } = unregisteredParticipants;

    const { participantId, participantEmail, status, demographics } = participant || {};
    const { firstName, lastName, dob, externalId, siteName } = demographics || {};

    const participantSelected = demographics ? participantsToRegister.some(id => id === externalId) : null;

    return (
      <tr key={participantId === guidEmpty ? externalId : participantId}>
        <td><input type="checkbox" checked={participantSelected} onChange={e => selectParticipant(externalId, status)}/></td>
        <td>{firstName}</td>
        <td>{lastName}</td>
        <td>{participantEmail}</td>
        <td>{dateUtilities.getUserFriendlyFormatFromJson(dob)}</td>
        <td>{siteName}</td>
      </tr>);
  }

  onConfirmModalClose(e, participants, pageParticipantData, result) {
    const { unregisteredParticipantsActions} = this.props;
    const { closeConfirmModal } = unregisteredParticipantsActions;

    if(!!result) this.handleRegisterParticipants(participants, pageParticipantData);
    closeConfirmModal();
  }

  onShowConfirmModal(e, participantsToRegisterCount) {
    e.preventDefault();
    const { unregisteredParticipantsActions} = this.props;
    const { showSubmitConfirmModal } = unregisteredParticipantsActions;

    const confirmText = `Are you sure you want to grant ${tenantHelpers.getProductName()} access to the ` + participantsToRegisterCount + " selected user(s)?";

    accessibilityNotificationsEmitter.assertive(confirmText);
    showSubmitConfirmModal();
  }

  handleRegisterParticipants(participants, pageParticipantData){
    const { unregisteredParticipantsActions, redirectTo } = this.props;
    var participantIds = [];
    var minValidEmail = false;
    var p, pId;
    for(var i=0; i<participants.size; i++){
      // verify that at least one participant has valid email address
      pId = participants.get(i);
      p = findParticipant(pId, pageParticipantData);
      if(!!p && !!p.demographics && !!p.demographics.email && emailUtilities.isValidEmail(p.demographics.email))
        minValidEmail = true;

      participantIds.push(participants.get(i));
    }
    if(minValidEmail){
      unregisteredParticipantsActions.registerParticipants(participantIds);
      unregisteredParticipantsActions.clearParticipantsToRegister();
      redirectTo('/registration');
    } else{
      toastr.error("Invalid Email", `Select Participants with valid email addresses; email is required for ${tenantHelpers.getProductName()} access.`);
    }
  }

  handleRestrictAuditChange(e) {
     const { unregisteredParticipantsActions } = this.props;
     const { unrestrictAuditDate, restrictAuditDate, startSearch } = unregisteredParticipantsActions;

    //default to all participants updated in the past year
    const lastYear = moment().subtract(365, 'days').startOf('day').format();

     const target = e.target;
     if(target.type === 'checkbox') {
       if(!target.checked) {
         unrestrictAuditDate();
         startSearch();
       }
       else {
         restrictAuditDate(lastYear);
         startSearch();
       }
     }
  }

  render() {
    const { unregisteredParticipants, unregisteredParticipantsActions, sites,
      programState } = this.props;
    const { changeSort, changePageNumber, changeResultsPerPage, selectAllParticipants, setSearchText, startSearch } = unregisteredParticipantsActions;
    const { pagingData, listState, participantsToRegister, searchInput, searchQuery, auditDateRestricted, showConfirmModal } = unregisteredParticipants;
    const { itemsPerPage, sortBy, sortAsc } = pagingData || {};
    const { isFetching, err, data } = listState || {};
    const { isFetching: isFetchingSites } = sites || {};

    const siteData = sites && sites.siteListState && sites.siteListState.data && sites.siteListState.data.results;

    const { isFetching: isFetchingPrograms } = programState || {};
    const isSiteSelected = sites && sites.selectedSiteId && sites.selectedSiteId !== emptyGuid;

    const progData = sites && sites.programLists && sites.programLists.get(sites.selectedSiteId);
    const programData = progData && progData.data;

    const currentSelectedSite = sites.selectedSiteId;
    const currentSelectedProgram = sites.selectedProgramId;

    const siteList = [{ value : null, label : '--Select--'}];
    !!siteData && siteData.forEach(site => {  siteList.push({ value: site.id, label: site.name })});

    const programList = [{ value : null, label : '--Select--'}];
    !!programData && programData.forEach(program => {  programList.push({ value: program.id, label: program.name })});
    const isSiteDisabled = isFetchingSites || isFetchingPrograms;
    const isProgramDisabled = !isSiteSelected || isFetchingSites || isFetchingPrograms;

    var participantList = [];
    var currentPage = 1;
    var totalItemsCount = 0;
    if(data) {
      participantList = data.results;
      currentPage = data.currentPage;
      totalItemsCount = data.totalResults;
    }

    if (err) {
      return <GenericError err={err} />
    }

    const allParticipantsSelected = isFetching ? false : participantList.every(val =>
      participantsToRegister.some(id => id === val.demographics.externalId));

      const headerNames = new Map([
        ['fname', {
          displayName: 'FIRST NAME',
          dataType: 'alpha' }],
        ['lname', {
          displayName: 'LAST NAME',
          dataType: 'alpha' }],
        ['email', {
          displayName: 'EMAIL',
          dataType: 'alpha' }],
        ['dob', {
          displayName: 'DATE OF BIRTH',
          dataType: 'date' }],
        ['site', {
          displayName: 'SITE',
          dataType: 'alpha',
          sortName: 'Site Name' }]]);

    const headerColumns = pagedListUtilities.buildSortHeader(headerNames, sortBy, sortAsc, changeSort);


    const sortText =  pagedListUtilities.getSortText(headerNames, sortBy, sortAsc);
    const sortMessage = " Participants sorted by " + sortText;
    const contentLoadedMessage = "Content Loaded. " + sortMessage;

    const headers = (
      <tr>
        <th><input type="checkbox" checked={allParticipantsSelected} onChange={e => selectAllParticipants()}/></th>
        {headerColumns}
      </tr>
    );

    const perPageOptions = [
      { value : 5, label : '5' },
      { value : 10, label : '10' },
      { value : 25, label : '25' },
      { value : 50, label : '50' }
    ];

    const createBtn = participantsToRegister && participantsToRegister.size > 0 ?
      <button
        id='btn-register'
        className='btn btn-primary centered-button'
        onClick={e => this.onShowConfirmModal(e, participantsToRegister.size)} >
        Create {tenantHelpers.getProductName()} Account {<span>({participantsToRegister.size})</span>}
      </button> :
      <button
        id='btn-register'
        className='btn btn-primary centered-button'
        onClick={e => this.onShowConfirmModal(e, participantsToRegister.size)}
        disabled>
        Create {tenantHelpers.getProductName()} Account
      </button>;
      const loadingMessage = !!auditDateRestricted ?
        "Loading unregistered participants updated within the last year..." :
        "Loading all unregistered participants...";

      const saveOptions = List([
        { id: 0, value: 'true', label: "Search by Site / Program" },
        { id: 1, value: 'false', label: "Search by last name / email" }
      ]);

    return (
      <div id='unregistered-participants'>
        <div className='radio-button'>
            <RadioElement
              isRequired={false}
              label=""
              options={saveOptions}
              disabled={false}
              defaultValue={List([unregisteredParticipants.radioButtonValue])}
              onChange={(value) => this.handleSelectionChange(value)}
              css={{ buttonWrapper: 'col-md-5', buttonLabel: 'save-list', radioButton: 'save-list', label: 'save-list'}}  />
        </div>
        <div className='search-component'>
          {unregisteredParticipants.radioButtonValue === 'false' ?
            <SearchComponent
              instructionText={'Enter part or all of the user’s last name or email address and click Search to filter.'}
              searchInput={searchInput}
              searchQuery={searchQuery}
              setSearchText={text => setSearchText(text)}
              startSearch={() => startSearch()}
              /> :
            <SiteProgramSearchComponent
              siteList={siteList}
              currentSelectedSite={currentSelectedSite}
              isSiteDisabled={isSiteDisabled}
              isFetchingSites={isFetchingSites}
              programList={programList}
              currentSelectedProgram={currentSelectedProgram}
              isProgramDisabled={isProgramDisabled}
              isFetchingPrograms={isFetchingPrograms}
              handleUpdateSite={selectedSite => this.handleUpdateSite(selectedSite)}
              handleUpdateProgram={selectedProgram => this.handleUpdateProgram(selectedProgram)}
              startSearch={() => startSearch()}
            />
          }

          {/* TODO: removing this until the CSV export feature is available
          <button className='btn btn-default right-align' aria-label='CSV Export'>
            <span className='glyphicon glyphicon-export'/>
          </button>
          */}
          <div className='search-component'>
            <label htmlFor='restrictAudit'>
              <input id="restrictAudit"
                    type={"checkbox"}
                    checked={!!auditDateRestricted}
                    onChange={e => this.handleRestrictAuditChange(e)}
                    aria-label={"Restrict list to participants updated within the last year."}
                    aria-checked={!!auditDateRestricted} role="checkbox" tabIndex="0"
              />
            </label>
            <span>Restrict list to participants updated within the last year.</span>
          </div>
        </div>
        <PagedList
          header={headers}
          items={participantList}
          emptyMessage={<p>No Unregistered Participants Found</p>}
          mapItem={participant => this.renderParticipant(participant)}
          currentPage={currentPage}
          resultsPerPage={itemsPerPage}
          variableResultsPerPage={true}
          perPageOptions={perPageOptions}
          totalItemsCount={totalItemsCount}
          changePageNumber={page => changePageNumber(page)}
          changeResultsPerPage={numResults => changeResultsPerPage(numResults)}
          isLoading={isFetching}
          loadingMessage={loadingMessage}
          contentLoadedMessage={contentLoadedMessage} />
        <div className='center-align'>
          {createBtn}
        </div>

        <ConfirmModalWindow
            show={showConfirmModal}
            title={"Register Participants"}
            onClose={(e, result) => this.onConfirmModalClose(e, participantsToRegister, participantList, result) }>
          <div className="form-horizontal survey">
            <p>{`Are you sure you want to grant ${tenantHelpers.getProductName()} access to the ` + participantsToRegister.size + " selected user(s)?"}</p>
          </div>
        </ConfirmModalWindow>
      </div>
    );
  }
}

UnregisteredParticipantsComponent.propTypes = {
  unregisteredParticipants: PropTypes.any,
  unregisteredParticipantsActions: PropTypes.any,
  redirectTo : PropTypes.func,
  auditDateRestricted: PropTypes.object,
  currentSelectedSite: PropTypes.string,
  currentSelectedProgram: PropTypes.string
};

const mapStateToProps = ({ unregisteredParticipants, sites }) => {
  return {
    unregisteredParticipants,
    sites
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    unregisteredParticipantsActions: bindActionCreators(unregisteredParticipantsActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
    sitesActions: bindActionCreators(sitesActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UnregisteredParticipantsComponent);
